<template>
  <div>
    <CRow class="">
      <CCol sm="12" v-if="loading" class="vh-100">
        <div class="d-flex justify-content-center align-items-center" style="height: 30vh">
          <CSpinner color="custom-color" style="width: 4rem; height: 4rem" />
        </div>
      </CCol>
      <template v-else>
        <template v-if="isVisible">
          <CCol sm="12" class="stepOneFirstBlock" style="border-bottom: 1px solid #e9ecef">
            <CRow>
              <CCol class="p-4 m-auto" style="max-width: 1180px">
                <center>
                  <Steps :currentStep="currentStep" />
                </center>
              </CCol>
            </CRow>
          </CCol>
          <div class="cartIconDiv" @click="showCart = true" v-show="currentStep == 1">
            <CIcon name="cart" class="text-gray-600 cartIcon" size="custom-size" :height="40" viewBox="0 0 40 40" />
            <div v-show="cartPackges.length > 0" class="cartQtd">{{ cartPackges.length }}</div>
          </div>

          <div class="cartNotification" v-show="showCartNotification">
            <CRow>
              <CCol md="7" class="cartNotificationText">
                <div>
                  {{ $t('balance.components.cart.packOf') }} <strong>{{ lastSelectedPackName }}</strong> {{ $t('balance.components.cart.hasAdded') }}
                </div>
              </CCol>
              <CCol class="colShowCartNotification">
                <div @click="showCart = true" class="showCartNotification">Show</div>
              </CCol>
              <CCol>
                <div @click="closeNotification" class="closeCartNotification">X</div>
              </CCol>
            </CRow>
          </div>
        </template>
        <template class="w-100" v-if="currentStep == 1">
          <ManageBalance />
        </template>

        <template v-if="currentStep == 2">
          <CCol xs="12" sm="12" class="mt-4">
            <CContainer class="py-4">
              <CRow class="pageManageBalance justify-content-md-center">
                <CCol xs="12" sm="6">
                  <WrapperCard>
                    <template slot="title">
                      <span class="font-xl">
                        {{ $t('manageBalance.billingForm.title') }}
                      </span>
                    </template>
                    <FormBilling />
                  </WrapperCard>
                </CCol>
                <CCol xs="12" sm="5">
                  <WrapperCard>
                    <template slot="title">
                      <span class="font-xl">
                        {{ $t(`manageBalance.planSummary.yourPlan`) }}
                      </span>
                      <a href="" class="font-weight-normal" @click.prevent="goToStep(1)">
                        {{ $t(`manageBalance.planSummary.edit`) }}
                      </a>
                    </template>
                    <CardPlan />
                    <!-- <CardPlan place="summary" /> 
                    <PayPeriod /> -->
                    <CardSubTotal />
                    <CardTotals />
                  </WrapperCard>
                </CCol>
              </CRow>
            </CContainer>
          </CCol>
        </template>

        <template v-if="currentStep == 3">
          <CCol xs="12" sm="12" class="mt-4">
            <CContainer class="py-4">
              <CRow class="pageManageBalance justify-content-md-center">
                <CCol xs="12" sm="6">
                  <WrapperCard>
                    <template slot="title">
                      <span class="font-xl">
                        {{ $t(`manageBalance.paymentMethod.title`) }}
                      </span>
                    </template>
                    <CardPaymentMethod :cartPackges="cartPackges" />
                  </WrapperCard>
                </CCol>
                <CCol xs="12" sm="5">
                  <WrapperCard>
                    <template slot="title">
                      <span class="font-xl">
                        {{ $t(`manageplan.component.card.plan.title`) }}
                      </span>
                      <a href="" class="font-weight-normal" @click.prevent="goToStep(1)">
                        {{ $t(`manageplan.component.card.plan.edit`) }}
                      </a>
                    </template>
                    <CardPlan />
                    <!--<PayPeriod />-->
                    <CardSubTotal />
                    <CardTotals />
                  </WrapperCard>
                </CCol>
              </CRow>
            </CContainer>
          </CCol>
        </template>

        <template v-if="currentStep == 4">
          <CCol sm="12" class="mt-4" v-if="currentStep == 4">
            <CContainer class="py-4">
              <CRow class="pageManageBalance justify-content-md-center">
                <CCol xs="12" sm="6">
                  <WrapperCard>
                    <template slot="title">
                      <span class="font-xl">
                        {{ $t(`manageBalance.planSummary.packDetails`) }}
                      </span>
                      <a href="" class="font-weight-normal" @click.prevent="goToStep(1)">
                        {{ $t(`manageplan.component.card.plan.edit`) }}
                      </a>
                    </template>
                    <CardPlanSummary />
                  </WrapperCard>
                  <WrapperCard>
                    <template slot="title">
                      <span class="font-xl">
                        {{ $t('manageplan.component.card.billing-information.title') }}
                      </span>
                      <a href="#" class="font-weight-normal" @click.prevent="goToStep(2)">
                        {{ $t('manageplan.component.card.billing-information.edit') }}
                      </a>
                    </template>
                    <CardBillingInfo />
                  </WrapperCard>
                </CCol>
                <CCol xs="12" sm="5">
                  <WrapperCard>
                    <template slot="title">
                      <span class="font-xl">
                        {{ $t('manageplan.component.card.payment-method.title') }}
                      </span>
                      <a href="" class="font-weight-normal" @click.prevent="goToStep(3)">
                        {{ $t(`manageplan.component.card.plan.edit`) }}
                      </a>
                    </template>
                    <CardPayment :subTotal="cartTotalToday" />
                    <CardVoucher />
                    <!--<CardCodePromo /> -->
                    <CardTotals :totalPrice="cartTotalTodayWithIva" :hasPurchases="cartTotalToday >= 0 && currentStep == 4" />
                  </WrapperCard>
                </CCol>
              </CRow>
            </CContainer>
          </CCol>
        </template>
      </template>
    </CRow>

    <CModal :show.sync="modalpayment" :no-close-on-backdrop="true" :centered="true">
      <template #header>
        <div v-if="true"></div>
      </template>
      <component v-if="modalpayment" :is="modalComponent"></component>
      <template #footer>
        <div v-if="true"></div>
      </template>
    </CModal>

    <CModal size="lg" :show.sync="showCart" :title="$t('balance.components.cart.title')">
      <div class="modal-body-unset" v-show="cartPackges.length == 0">
        <p class="cart-empty-title">{{ $t('balance.components.cart.cartEmpty') }}</p>
        <div class="cart-empty-msg">{{ $t('balance.components.cart.cartEmptyMessage') }}</div>
        <CButton @click="showCart = false" class="w-25 py-3 font-weight-bold rounded-lg mt-4 mb-5 btn-primary">{{
          $t('balance.components.cart.cartBtnText')
        }}</CButton>
      </div>
      <div class="modal-body-seted" v-show="cartPackges.length > 0">
        <CRow class="pt-4 pb-4 rowCartItem" v-for="(pack, index) in cartPackges" :key="index">
          <CCol md="4">
            <div class="d-flex pt-3">
              <CIcon :name="pack.channel" class="" size="custom-size" label="teste" :height="25" viewBox="0 0 32 32" />
              <div class="mb-0 font-md ml-2 font-weight-bold">{{ pack.packName }}</div>
            </div>
            <div class="col-md-12" v-if="pack.channel == 'sms'">
              <div class="itemDetailBlock">
                <img :src="getCountryFlag(pack.country)" width="25" height="auto" class="mr-2" />
                <strong>{{ getCountryLabel(pack.country) }}</strong>
              </div>
            </div>
            <div class="col-md-12">
              <div class="itemDetailBlock">
                <div @click="removeCartItem(index)" class="removeItem w-25">{{ $t('balance.components.cart.removeItem') }}</div>
              </div>
            </div>
          </CCol>
          <CCol md="5">
            <div class="d-flex">
              <div>
                <div class="d-flex mt-2 add-or-subtract">
                  <div class="p-2 pl-3 pr-3 cartInputItem" @click="decreaseQuantity(pack)">
                    <CIcon name="minus" class="" size="custom-size" label="teste" :height="10" viewBox="0 0 32 32" />
                  </div>
                  <div class="p-2 pl-3 pr-3 font-weight-bold">{{ pack.quantity }}</div>
                  <div class="p-2 pl-3 pr-3 cartInputItem" @click="addQuantity(pack)">
                    <CIcon name="plus" class="" size="custom-size" label="teste" :height="10" viewBox="0 0 32 32" />
                  </div>
                </div>
              </div>
              <div class="add-or-subtract-text pt-2 ml-3">
                {{ pack.quantityPackage }} {{ pack.channel }} {{ $t('balance.components.cart.inTotal') }}
              </div>
            </div>
          </CCol>
          <CCol md="3">
            <div v-if="pack.package.packSelected.addOnRecurrenceType == 1" class="pt-2">{{ $t('balance.components.cart.recurringPack') }}</div>
            <div v-if="pack.package.packSelected.addOnRecurrenceType == 2" class="pt-2">{{ $t('balance.components.cart.oneShot') }}</div>
            <div class="pt-1 font-weight-bold">
              {{ currentFormat(pack.package.packSelected.price * pack.quantity) }} €
              <span v-if="pack.package.packSelected.addOnRecurrenceType == 1">/ {{ $t('balance.components.cart.month') }}</span>
            </div>
          </CCol>
        </CRow>

        <template class="priceSummary">
          <div class="d-flex justify-content-end mt-4">
            <div class="todayTotal mr-5">{{ $t('balance.components.cart.todayTotal') }}</div>
            <div class="todayTotal">{{ currentFormat(cartTotalToday) }} €</div>
          </div>
          <!-- <div class="d-flex justify-content-end mt-3">
            <div class="add-or-subtract-text">{{ $t('balance.components.cart.perMonth') }}</div>
          </div>
          <div class="d-flex justify-content-end mt-1">
            <div class="add-or-subtract-text">{{ $t('balance.components.cart.willBeCharged') }}</div>
          </div>
          <div class="d-flex justify-content-end">
            <div class="add-or-subtract-text">{{ $t('balance.components.cart.andRegularPlanPrice') }}</div>
          </div> -->
        </template>
      </div>

      <template #footer>
        <div v-show="cartPackges.length > 0"></div>
        <div v-show="cartPackges.length > 0">
          <CButton @click="showCart = false" class="py-3 font-weight-bold rounded-lg btn mr-4 btn-border">{{
            $t('balance.components.cart.btnContinue')
          }}</CButton>
          <CButton @click="proceedToBilling" class="py-3 font-weight-bold rounded-lg btn-primary">{{
            $t('balance.components.cart.btnProceed')
          }}</CButton>
        </div>
      </template>
    </CModal>
  </div>
</template>

<script>
import ManageBalance from './ManageBalance.vue'
import Steps from '../components/Steps.vue'
import WrapperCard from '../components/cards/WrapperCard.vue'
import CardPlan from '../components/cards/CardPlan.vue'
import CardPlanSummary from '../components/cards/CardPlanSummary.vue'
import CardTotals from '../components/cards/CardTotals.vue'
import PayPeriod from '../components/cards/PayPeriod.vue'
import CardSubTotal from '../components/cards/CardSubTotal.vue'
import CardPayment from '../components/cards/CardPayment.vue'
import CardVoucher from '../components/cards/CardVoucher.vue'
import FormBilling from '../components/FormBilling.vue'
import CardBillingInfo from '../components/cards/CardBillingInfo.vue'
import CardPaymentMethod from '../components/cards/CardPaymentMethod.vue'
import CardCodePromo from '../components/cards/CardCodePromo.vue'
import { currencyFormat, currencyFormatStyleEnum } from '../../../utils/numbersFormatUtil'

import { getItem } from '@/utils/StorageManager'
import services from '@/services.js'

const typeList = {
  email: 1,
  sms: 2,
}

export default {
  name: 'ManagePlans',
  components: {
    ManageBalance,
    Steps,
    WrapperCard,
    CardPlan,
    CardPlanSummary,
    CardTotals,
    PayPeriod,
    CardSubTotal,
    FormBilling,
    CardPaymentMethod,
    CardPayment,
    CardBillingInfo,
    CardCodePromo,
    CardVoucher,
    ModalLoadingPayment: () => import('./../components/modals/ModalLoadingPayment.vue'),
    ModalSuccessPayment: () => import('./../components/modals/ModalSuccessPayment.vue'),
    ModalContactForm: () => import('./../components/modals/ModalContactForm.vue'),
    ModalErrorPayment: () => import('./../components/modals/ModalErrorPayment.vue'),
    ModalPlanDetail: () => import('./../components/modals/ModalPlanDetail.vue'),
  },

  data() {
    return {
      loading: false,
      organizationId: null,
      targetOrganizationId: false,
      organizationName: '',
      currentBalance: [],
      channel: null,
      edit: true,
      insertBillingInfo: false,
      optionsCountriesNames: [],
      socialDesigination: '',
      taxIdentificationNumber: '',
      address: '',
      postalCode: '',
      city: '',
      country: '',
      phoneCountryIndicator: '',
      phoneNumber: '',
      email: '',
      managePlans: [],
      selectedPlanId: '',
      selectedPlanName: '',
      maxAudience: 500,
      maxEmailsIncluded: 0,
      billingInfo: null,
      isFormActive: false,
      showCart: false,
    }
  },

  created() {
    this.setStateSteps()
    this.organizationId = this.$route.params.organizationId
    this.targetOrganizationId = this.$route.params.targetOrganizationId
    this.organizationName = this.$store.state.auth.organizationName
  },

  beforeDestroy() {
    this.$store.commit('balance/steps/RESET_STEP')
  },

  mounted() {
    this.billingInfo = this.$store.state.balance.steps.billingInfo
    this.changeMaxAudience(500) //seta o valor inicial mínimo
    this.setStateSteps()
  },

  beforeMount() {
    this.getPlans()
  },

  computed: {
    currentStep() {
      return this.$store.state.balance.steps.currentStep || 1
    },

    modalPlanDetails() {
      return this.$store.state.balance.steps.modalPlanDetails
    },

    modalpayment() {
      return this.$store.state.balance.steps.modalpayment
    },

    modalComponent() {
      return this.$store.state.balance.steps.componentOpenedInModal
    },

    cartPackges() {
      return this.$store.state.balance.steps.cartPackges
    },

    showCartNotification() {
      return this.$store.state.balance.steps.showCartNotification
    },

    lastSelectedPackName() {
      return this.$store.state.balance.steps.lastSelectedPackName
    },

    cartTotalToday() {
      var count = 0
      this.cartPackges.forEach((pack) => (count = count + pack.package.packSelected.price * pack.quantity))
      return count
    },
    cartTotalTodayWithIva() {
      var count = 0
      this.cartPackges.forEach((pack) => (count = count + pack.package.packSelected.price * pack.quantity))
      var iva = this.$store.state.balance.steps.iva / 100
      var countWithIva = count * iva + count
      return countWithIva.toFixed(1)
    },
    hasPayAsYouGoRouteParams() {
      return Boolean(this.$route.query.selectedPlanId)
    },
    isVisible() {
      const NO_OWN_BALANCE = 1
      const OWN_BALANCE_DEPENDENT = 2
      const OWN_BALANCE_INDEPENDENT = 3
      const STANDARD = 2
      const PAY_AS_YOU_GO = 5

      if (
        (this.$store.state.auth.session.organization?.organizationBalanceConfigType == OWN_BALANCE_INDEPENDENT &&
          this.$store.state.auth.session.organization?.planType == STANDARD) ||
        this.$store.state.auth.session.organization?.planType == PAY_AS_YOU_GO ||
        this.hasPayAsYouGoRouteParams
      ) {
        return true
      }

      return false
    },
  },

  methods: {
    currentFormat(number) {
      if (number) return currencyFormat(number, currencyFormatStyleEnum.DECIMAL)
      return
    },

    proceedToBilling() {
      this.showCart = false
      this.$store.dispatch('balance/steps/setCurrentStep', 2)
    },
    getCountryFlag(country) {
      switch (country) {
        case 'PT':
          return '/img/flags/pt.svg'

        case 'MZ':
          return '/img/flags/mz.svg'

        case 'RoW':
          return '/img/flags/row.svg'

        case 'ES':
          return '/img/flags/es.svg'
      }
    },
    getCountryLabel(country) {
      switch (country) {
        case 'PT':
          return 'Portugal'

        case 'MZ':
          return 'Mozambique'

        case 'RoW':
          return 'Rest of World'

        case 'ES':
          return 'Spain'
      }
    },
    decreaseQuantity(pack) {
      var cartItem = this.cartPackges.filter((item) => item.package.packSelected.id == pack.package.packSelected.id)
      if (cartItem[0].quantity > 1) {
        var cartNewItem = {
          package: cartItem[0].package,
          channel: cartItem[0].channel,
          quantityPackage: cartItem[0].quantityPackage,
          packName: cartItem[0].packName,
          quantity: cartItem[0].quantity - 1,
        }

        this.$store.dispatch('balance/steps/updateInfoPropStep', { prop: 'cartPackges', data: cartNewItem })
      }
    },
    addQuantity(pack) {
      var cartItem = this.cartPackges.filter((item) => item.package.packSelected.id == pack.package.packSelected.id)
      var cartNewItem = {
        package: cartItem[0].package,
        channel: cartItem[0].channel,
        quantityPackage: cartItem[0].quantityPackage,
        packName: cartItem[0].packName,
        quantity: cartItem[0].quantity + 1,
      }

      this.$store.dispatch('balance/steps/updateInfoPropStep', { prop: 'cartPackges', data: cartNewItem })
    },
    closeNotification() {
      this.$store.dispatch('balance/steps/updateInfoPropStep', { prop: 'showCartNotification', data: false })
    },
    getPlans() {
      this.loading = true
      services
        .getPlans(this.organizationId)
        .then((res) => {
          this.managePlans = res.data.data
        })
        .finally(() => {
          this.loading = false
        })
    },

    goToStep(step, selectedPlan = null) {
      if (step == 3 && this.billingInfo) {
        this.$store
          .dispatch('balance/steps/validateBillingInfo', {
            organizationId: this.organizationId,
            prop: 'billingInfo',
            info: this.billingInfo,
          })
          .then(() => {
            this.$store.dispatch('balance/steps/setCurrentStep', 3)
          })
          .catch((error) => {
            console.log('catch', error, error.response)
            this.messages.push({
              status: 'danger',
              text: error.response.data.data.message || 'erro',
            })
          })
      }

      if (selectedPlan !== null) {
        this.selectedPlanId = selectedPlan.id
      }

      this.$store.dispatch('balance/steps/setCurrentStep', step)
    },

    changeMaxAudience(value) {
      if (value < 50001) {
        this.isFormActive = false
      }
      this.maxAudience = value
      this.$store.dispatch('balance/steps/updateInfoPropStep', { prop: 'maxAudience', data: value })
    },

    getPriceByPlanIdAndMaxAudience(planId) {
      let plans = this.managePlans.plans
      let plan = plans.find((item) => item.id === planId)
      let planTier = plan.planTiers.find((it) => it.maxAudienceRecipients == this.maxAudience)
      if (typeof planTier != 'undefined') {
        return planTier.periodPlanTierPrice.price
      }
      return
    },

    getMaxEmailByPlanIdAndMaxAudience(planId) {
      let plans = this.managePlans.plans
      let plan = plans.find((item) => item.id === planId)
      let planTier = plan.planTiers.find((it) => it.maxAudienceRecipients == this.maxAudience)
      if (typeof planTier != 'undefined') {
        this.maxEmailsIncluded = planTier.maxEmailsPerMonth
        return planTier.maxEmailsPerMonth
      }
      return
    },

    getFeaturesByPlan(featureId, planId) {
      let plan = this.managePlans.plans.find((it) => it.id === planId)
      let plansFeatures = []

      if (plan.features.length > 0) {
        let ft = plan.features.find((item) => item.fetaureType === featureId)
        if (typeof ft != 'undefined') {
          plansFeatures.push(ft)
        } else {
          plansFeatures.push({ id: 'null', metadata: { valueKind: 'null' } })
        }
      }
      return plansFeatures
    },

    setModal(data) {
      this.$store.dispatch('balance/steps/setModalComponent', data)
    },

    closeModal() {
      this.$store.dispatch('balance/steps/closeModalComponent')
    },

    currentStepStep(stepNumber) {
      this.$store.dispatch('balance/steps/setCurrentStep', stepNumber)
    },

    setStateSteps() {
      const stateStepAddons = JSON.parse(getItem('stateStepAddons'))

      if (stateStepAddons) {
        this.$store.dispatch('balance/steps/updateInfoStep', stateStepAddons)
        this.currentStepStep(stateStepAddons.currentStep)
      }
    },

    removeCartItem(index) {
      this.$store.dispatch('balance/steps/removeCartItem', { data: index })
    },

    getQuantityByPackId(packId) {
      var packsById = this.cartPackges.filter((item) => item.package.packSelected.id == packId)
      return packsById.length
    },
  },
}
</script>

<style lang="scss" scoped>
.pageManageBalance__campaignName {
  border-bottom: 1px solid var(--gray-300);
  line-height: 1.5em;
}

.bold {
  font-weight: bold;
}

ul.plan-steps {
  max-width: 60%;
  height: 30px;
  list-style: none;
  margin: 0;
  padding: 0;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  overflow: hidden;
  background-color: transparent !important;
}

ul.progress-bar {
  max-width: 80%;
  height: 30px;
  list-style: none;
  margin: 0;
  padding: 0;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  overflow: hidden;
  background-color: transparent !important;
}
ul.progress-bar::after {
  content: '';
  position: absolute;
  left: 5px;
  background: #777;
  width: 100vw;
  height: 5px;
  margin-top: 6px;
}
ul.progress-bar li {
  background: #000;
  border-radius: 100px;
  width: 18px;
  height: 18px;
  z-index: 1;
  position: relative;
}
ul.progress-bar li.stop ~ li {
  background: #777;
}
ul.progress-bar li.stop ~ li::after {
  height: 0;
}
ul.progress-bar li::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 5px;
  background: #000;
  width: 5px;
  height: 100vh;
}

.bs-wizard {
  margin-top: 40px;
}

/*Form Wizard*/
.bs-wizard {
  border-bottom: solid 1px #e0e0e0;
  padding: 0 0 10px 0;
  margin-top: 5px;
}
.bs-wizard > .bs-wizard-step {
  padding: 0;
  position: relative;
}
.bs-wizard > .bs-wizard-step + .bs-wizard-step {
}
.bs-wizard > .bs-wizard-step .bs-wizard-stepnum {
  color: #868e96;
  font-size: 14px;
  margin-bottom: 5px;
}
.bs-wizard > .bs-wizard-step .bs-wizard-info {
  color: rgb(102, 102, 102);
  font-size: 14px;
}
.bs-wizard > .bs-wizard-step > .bs-wizard-dot {
  position: absolute;
  width: 26px; // 30 30
  height: 26px;
  display: block;
  background: #ff5924;
  top: 45px;
  left: 50%;
  margin-top: -15px;
  margin-left: -15px;
  border-radius: 50%;
}
.bs-wizard > .bs-wizard-step > .bs-wizard-dot:after {
  content: ' ';
  width: 11px; //14 14
  height: 11px;
  background: #ffe8e1;
  border-radius: 50px;
  position: absolute;
  top: 7px; //8 8
  left: 7.5px;
}
.bs-wizard > .bs-wizard-step > .progress {
  position: relative;
  border-radius: 0px;
  height: 8px;
  box-shadow: none;
  margin: 20px 0;
}
.bs-wizard > .bs-wizard-step > .progress > .progress-bar {
  width: 0px;
  box-shadow: none;
  background: #ff784f;
}
.bs-wizard > .bs-wizard-step.complete > .progress > .progress-bar {
  width: 100%;
}
.bs-wizard > .bs-wizard-step.active > .progress > .progress-bar {
  width: 50%;
}
.bs-wizard > .bs-wizard-step:first-child.active > .progress > .progress-bar {
  width: 0%;
}
.bs-wizard > .bs-wizard-step:last-child.active > .progress > .progress-bar {
  width: 100%;
}
.bs-wizard > .bs-wizard-step.disabled > .bs-wizard-dot {
  background-color: #868585;
}
.bs-wizard > .bs-wizard-step.disabled > .bs-wizard-dot:after {
  opacity: 0;
}
.bs-wizard > .bs-wizard-step:first-child > .progress {
  left: 50%;
  width: 50%;
}
.bs-wizard > .bs-wizard-step:last-child > .progress {
  width: 50%;
}
.progress {
  background-color: #afafaf;
}
.bs-wizard-dot {
  cursor: pointer;
}
/*END Form Wizard*/

.btn-default {
  background-color: rgb(189, 189, 189);
  color: rgb(92, 92, 92);
}

.linhaBusiness {
  color: #ff5924;
  position: absolute;
  right: 450px;
  bottom: 5px;
}

.titleBusiness {
  position: relative;
  height: 60px;
}

.subTitleBusiness {
  color: #868e96;
  font-size: 18px;
}

.container {
  padding-right: 0px;
  padding-left: 0px;
}

.stepOneFirstBlock {
  background-color: #fff;
}

.cartIcon {
  position: relative;
  color: #343a40;
}

.cartIconDiv {
  cursor: pointer;
  position: absolute;
  right: 10%;
  top: 35px;
}

.cartQtd {
  width: 20px;
  line-height: 15px;
  border-radius: 50%;
  text-align: center;
  font-size: 12px;
  border: 3px solid #403266;
  background-color: #403266;
  color: #fff;
  position: absolute;
  top: -8px;
  right: -5px;
}

.modal-body-unset {
  text-align: center;
}

.cart-empty-title {
  font-weight: 700;
  font-size: 20px;
  line-height: 120%;
  color: #343a40;
  margin-top: 13%;
}

.cart-empty-msg {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #868e96;
}

.btn-border {
  border: 1px solid #dedede !important;
}

.removeItem {
  color: #403266;
  text-decoration: underline;
  cursor: pointer;
}

.add-or-subtract-text {
  color: #868e96;
}

.add-or-subtract {
  border: 1px solid #dedede;
}

.rowCartItem {
  border-bottom: 1px solid #dedede;
}

.cartInputItem {
  cursor: pointer;
}

.todayTotal {
  font-size: 20px;
  color: #343a40;
  font-weight: bold;
}

.cartNotification {
  padding: 25px 20px;
  text-align: center;
  background-color: #fff;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  position: absolute;
  z-index: 4;
  right: 20px;
  top: 130px;
}

.showCartNotification {
  color: #403266;
  text-decoration: underline;
  font-size: 18px;
  margin-top: 9%;
  cursor: pointer;
  widows: 100%;
}

.colShowCartNotification {
  border-right: 1px solid #dee2e6;
  padding: 0;
}

.cartNotificationText {
  text-align: left;
  color: #343a40;
  font-size: 15px;
}

.closeCartNotification {
  color: #343a40;
  font-size: 22px;
  margin-top: 9%;
  cursor: pointer;
}

.itemDetailBlock {
  margin-left: 15px;
  margin-bottom: 20px;
  margin-top: 10px;
}
</style>
